import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      Actions: "Actions",
      Active: "Active",
      Add: "Add",
      Add_record: "Add record",
      Administrator: "Administrator",
      Administrators: "Administrators",
      An_error_occurred_while_trying_to_perform_the_operation:
        "An error occurred while trying to perform the operation",
      and: "and",
      Back: "Back",
      characters: "characters",
      Configurations: "Configurations",
      Create: "Create",
      Created_date: "Created date",
      Crop: "Crop",
      Crops: "Crops",
      Delete: "Delete",
      Destinations: "Destinations",
      Destination: "Destination",
      Edit: "Edit",
      View: "View",
      End_date: "End date",
      Fields: "Fields",
      Field: "Field",
      Go_to_page: "Go to page",
      Harvests: "Harvests",
      Harvest: "Harvest",
      Home: "Home",
      Hopper: "Hopper",
      Hoppers: "Hoppers",
      is_required: "is required",
      Latitude: "Latitude",
      Longitude: "Longitude",
      Login: "Login",
      Login_failed: "Login failed",
      Logistics_providers: "Logistics providers",
      Logistics_provider: "Logistics provider",
      Logout: "Logout",
      manager: "Textum",
      must_not_exceed: "must not exceed",
      Name: "Name",
      Notes: "Notes",
      Paddocks: "Paddocks",
      Page: "Page",
      Password: "Password",
      Purchasers: "Purchasers",
      Purchaser: "Purchaser",
      Search: "Search",
      Show: "Show",
      The: "The",
      Trucker: "Trucker",
      Truckers: "Truckers",
      User: "User",
      Users: "Users",
      Update: "Update",
      Updating: "Updating",

      DataTable: {
        currentPageReportTemplate:
          "Showing {first} to {last} of {totalRecords}",
        New: "New",
        Export: "Export",
        Search: "BusSearchcar",
      },
      Buttons: {
        Cancel: "Cancel",
        Create: "Create",
        Creating: "Creating",
        Update: "Update",
        Updating: "Updating",
        Delete: "Delete",
        Deleting: "Deleting",
      },
      forms: {
        validation: {
          max: "{{entity}} field must be {{max}} or less.",
          min: "{{entity}} field must be {{min}} or more.",
          maxLength: "{{entity}} field lenght must be {{maxLength}} or less",
          required: "{{entity}} is required.",
        },
        messages: {
          operation: {
            success: "Operation performed successfully.",
            error: "An error occurred while trying to perform the operation.",
          },
          titles: {
            Success: "Success",
            Error: "Error",
          },
        },
      },
    },
  },
  es: {
    translation: {
      Actions: "Acciones",
      Active: "Activo",
      Add: "Agregar",
      Add_record: "Nuevo registro",
      An_error_occurred_while_trying_to_perform_the_operation:
        "Ocurrió un error al intentar realizar la operación",
      and: "y",
      Back: "Volver",
      characters: "caracteres",
      Configurations: "Configuraciones",
      Created_date: "Fecha de inicio",
      Delete: "Borrar",
      Edit: "Editar",
      View: "Ver",
      End_date: "Fecha de fin",
      Go_to_page: "Ir a la página",
      Home: "Inicio",
      is_required: "es requerido",
      Login: "Iniciar sesión",
      Login_failed: "Error de inicio de sesion",
      Logout: "Salir",
      manager: "Textum",
      must_not_exceed: "no debe exceder",
      Name: "Nombre",
      Notes: "Notas",
      Page: "Página",
      Password: "Contraseña",
      Search: "Buscar",
      Show: "Mostrar",
      The: "El",
      Update: "Actualizar",
      Updating: "Actualizando",

      DataTable: {
        currentPageReportTemplate:
          "Mostrando de {first} hasta {last} de {totalRecords}",
        New: "Nuevo",
        Export: "Exportar",
        Search: "Buscar",
        emptyMessage: "No se encontraron registros",
      },
      buttons: {
        approve: "Aprobar",
        reject: "Rechazar",
        cancel: "Cancelar",
        create: "Crear",
        creating: "Creando",
        update: "Actualizar",
        updating: "Actualizando",
        delete: "Eliminar",
        deleting: "Eliminando",
        close: "Cerrar",
        closing: "Cerrando",
        yes: "Si",
        no: "No",
      },
      menu: {
        business: "Negocio",
        applications: "Solicitudes",
        credits: "Créditos",
        withholdings: "Retenciones",
        installments: "Cuotas",
        users: "Usuarios",
        administrators: "Administradores",
        beneficiaries: "Beneficiarios",
        registrations: "Registros",
        client: "Cliente",
        reports: "Reportes",
        reportWithholdingsByPeriod: "Retenciones por período",
        reportBeneficiaryTimeline: "Línea de tiempo",
      },
      forms: {
        validation: {
          max: "{{entity}} debe ser menor o igual a {{max}}.",
          min: "{{entity}} debe ser mayor o igual a {{min}}.",
          maxLength: "{{entity}} no debe superar los {{maxLength}} caracteres.",
          required: "{{entity}} es requerido.",
          noValidEmail: "Email no válido.",
        },
        messages: {
          operation: {
            success: "Operación realizada con exito.",
            error:
              "Un error ocurrió mientras se intentaba realizar la operación.",
            deleteErrorReference:
              "No se puede eliminar la entidad por estar relacionada a otras entidades.",
            updateErrorReference: "No se puede modificar la entidad.",
            activeInactiveOption:
              "Intente con la funcionalidad de 'Activo/Inactivo'",
          },
          titles: {
            success: "Exito",
            error: "Error",
            confirmation: "Confirmación",
            suggestion: "Sugerencia",
          },
        },
        options: {
          toContinue: "¿Desea continuar?",
        },
      },
      errors: {
        general:
          "Un error ocurrió mientras se intentaba realizar la operación.",
        login: "Ocurrió un error al intentar ingresar al sistema",
        duplicatedMail: {
          title: "Mail duplicado",
          message: "Ya existe un usuario con el mail ingresado.",
        },
        unauthorized: "Usuario no autorizado",
      },
      entities: {
        administrators: {
          plural: "Administradores",
          singular: "Administrador",
          name: "Nombre",
          nick: "Usuario",
          phone: "Teléfono",
          notes: "Notas",
          active: "Activo",
          email: "Email",
          password: "Contraseña",
          showPassword: "Mostrar contraseña",
          hidePassword: "Ocultar contraseña",
        },
        applications: {
          plural: "Solicitudes",
          singular: "Solicitud",
          amount: "Monto",
          installmentsNumber: "Cuotas",
          installmentsAmount: "Cuota",
          answerDate: "Fecha de respuesta",
          answer: "Respuesta",
          answerDetail: "Mensaje",
          beneficiary_LastName: "Apellido",
          beneficiary_Name: "Nombre",
          beneficiary_DocumentType: "Tipo de documento",
          beneficiary_DocumentNumber: "Documento",
          beneficiary_Email: "Email",
          beneficiary_DocumentNumber: "Documento",
          beneficiary_Phone: "Teléfono",
          beneficiary_Address: "Dirección",
          annualRate: "Interés anual",
          annualDefaultRate: "Interés moratorio anual",
          administrationFeeRate: "Gastos administrativos",
          createdDate: "Fecha de creación",
          images: "Imágenes",
          imagesDescription: {
            beneficiaryDocument: "Documento",
            beneficiaryAddress: "Comprobante de domicilio",
            beneficiarySalaryReceipt1: "Recibo de sueldo 1",
            beneficiarySalaryReceipt2: "Recibo de sueldo 2",
            beneficiarySalaryReceipt3: "Recibo de sueldo 3",
          },
          states: {
            pending: "Pendientes",
            approved: "Aprobadas",
            rejected: "Rechazadas",
          },
          type: "Tipo",
          types: {
            NEW_CREDIT: "Nuevo crédito",
            RENEWAL: "Renovación",
          },
          errors: {
            alreadyAnswered:
              "La solicitud ya ha sido anteriormente respondida y no puede ser modificada.",
            withholdingInProgress:
              "Existe una retención en proceso para el beneficiario de esta solicitud.",
          },
        },
        beneficiaries: {
          plural: "Beneficiarios",
          singular: "Beneficiario",
          lastName: "Apellido",
          name: "Nombre",
          documentType: "Tipo de documento",
          documentNumber: "Documento",
          phone: "Teléfono",
          address: "Dirección",
          notes: "Notas",
          active: "Activo",
          nick: "Usuario",
          email: "Email",
          password: "Contraseña",
          showPassword: "Mostrar contraseña",
          hidePassword: "Ocultar contraseña",
        },
        clients: {
          plural: "Clientes",
          singular: "Cliente",
          name: "Nombre",
          rut: "RUT",
          address: "Dirección",
          phone: "Teléfono",
          notes: "Notas",
          active: "Activo",
          email: "Email",
          logo: "Logo",
          password: "Contraseña",
          clientsInstallmentsAmountsCollection: "Montos dispoibles",
          clientsInstallmentsNumbersCollection: "Cuotas disponbles",
          settings: "Configuración",
          clientsSettings: {
            administrationFeeRate: "Gastos administrativos",
            annualDefaultRate: "Iterés moratorio anual",
            annualRate: "Iterés anual",
          },
          installmentsAmounts: "Montos disponibles",
          installmentesNumbers: "Cantidad de cuotas disponibles",
        },
        credits: {
          plural: "Créditos",
          singular: "Crédito",
          id: "Número",
          code: "Número",
          openedDate: "Apertura",
          closedDate: "Cierre",
          application: {
            beneficiary_documentNumber: "Documento",
            beneficiary_name: "Nombre",
            beneficiary_lastName: "Apellido",
            beneficiary_phone: "Teléfono",
            beneficiary_address: "Dirección",
            amount: "Capital",
            installmentsAmount: "Cuota",
            installmentsNumber: "Plazo",
            administrationFeeRate: "Gastos",
            annualRate: "Interés",
            annualDefaultRate: "Mora",
          },
        },
        payments: {
          plural: "Pagos",
          singular: "Pago",
          amount: "Monto",
          date: "Fecha",
          status: "Estado",
          statusDate: "Modificado",
          statusCollection: {
            pending: "Pendiente",
            approved: "Aprobado",
            rejected: "Rechazado",
          },
          errors: {
            paymentAlreadyApproved:
              "El pago ya ha sido aprobado y no se puede modificar",
          },
        },
        registrations: {
          plural: "Registros",
          singular: "Registro",
          createdDate: "Fecha de creado",
          documentType: "Tipo de documento",
          documentNumber: "Documento",
          name: "Nombre",
          lastName: "Apellido",
          phone: "Teléfono",
          address: "Dirección",
          answerDate: "Fecha de respuesta",
          answer: "Aceptado",
          pending: "Pendiente",
          approved: "Aprobado",
          notApproved: "No aprobado",
          errors: {
            registrationAlreadyApproved:
              "El registro ya ha sido aprobado y no se puede modificar",
          },
        },
        installments: {
          plural: "Cuotas",
          singular: "Cuota",
          number: "# Cuota",
          capital: "Capital",
          interests: "Intereses",
          interests: "Intereses",
          interestsTaxes: "Impuestos",
          expirationDate: "Vencimiento",
          installmentDate: "Cuota",
          creditId: "# Crédito",
          creditCode: "# Crédito",
          beneficiary_DocumentNumber: "Documento",
          pending: "Pendiente",
          status: "Estado",
          statusDate: "Modificado",
          credit: {
            application: {
              beneficiary_documentNumber: "Documento",
              beneficiary_name: "Nombre",
              beneficiary_lastName: "Apellido",
              beneficiary_phone: "Teléfono",
              beneficiary_address: "Dirección",
            },
          },
        },
        withholdings: {
          plural: "Retenciones",
          singular: "Retención",
          year: "Año",
          month: "Mes",
          sentDate: "Enviada",
          createdDate: "Creada",
          confirmedDate: "Confirmada",
          conciliationDate: "Conciliada",
          generate: "Generar",
          send: "Enviar",
          confirm: "Confirmar",
          conciliate: "Conciliar",
          notSent: "No enviada",
          notConfirmed: "No confirmada",
          notConciliated: "No conciliada",
          bill: "Facturar",
          billing: "Facturando",
          billingDate: "Fecha de facturación",
          notBilled: "Sin facturar",
          confirming: "Confirmando",
          confirmRetry: "Reintentar confirmación",
          confirmedLinesProgress: "{{confirmed}} de {{total}} líneas cobradas",
          billedLinesProgress: "{{billed}} de {{total}} líneas facturadas",
          pendingBillingNotice_one:
            "Falta 1 comprobante por emitir. El cobro ya está firme.",
          pendingBillingNotice_other:
            "Faltan {{count}} comprobantes por emitir. El cobro ya está firme.",
          billingDialogTitle: "Facturar retención {{month}}/{{year}}",
          billingDialogHelp_one:
            "Queda 1 comprobante por emitir. Elegí con qué fecha se emite.",
          billingDialogHelp_other:
            "Quedan {{count}} comprobantes por emitir. Elegí con qué fecha se emiten.",
          billingDateHelp:
            "Por defecto es la de hoy. Queda fija para toda la retención en cuanto se emita el primer comprobante.",
          billingDateFrozenHelp:
            "La fecha quedó fija en {{date}} porque ya hay comprobantes emitidos: los que falten tienen que llevar la misma.",
          billingDateFrozenError:
            "Ya hay comprobantes emitidos con fecha {{date}}: los que falten tienen que llevar esa misma fecha.",
          billingDateOutOfRange:
            "El facturador no acepta esa fecha: tiene que ser posterior al 01/10/2011 y no ir más allá de dos meses a futuro.",
          billingNotConfirmed:
            "La retención todavía no está confirmada. Primero se cobra, después se factura.",
          conciliateNeedsBilling:
            "Falta emitir comprobantes: se concilia una vez facturada.",
          conciliateNotBilled:
            "No se puede conciliar: quedan comprobantes por emitir. Facturá lo que falta y volvé a intentar. Las líneas que esperan verificación manual también cuentan.",
          confirmLineError:
            "Se frenó en la línea de {{beneficiary}}: {{reason}}. Lo ya procesado quedó firme; al reintentar se continúa desde esa línea.",
          confirmProgressTitle: "Confirmando retención {{month}}/{{year}}",
          billProgressTitle: "Facturando retención {{month}}/{{year}}",
          confirmProgressCurrent: "Procesando la línea de {{beneficiary}}...",
          phaseCollecting: "Cobro",
          phaseBilling: "Facturación",
          confirmSummaryTitle_one: "Quedó 1 línea sin cobrar",
          confirmSummaryTitle_other: "Quedaron {{count}} líneas sin cobrar",
          confirmSummaryHelp:
            "Las demás quedaron cobradas y firmes. Al reintentar se toman sólo éstas, sin repetir ningún pago.",
          confirmSummaryWithFailures_one: "Quedó 1 línea sin cobrar.",
          confirmSummaryWithFailures_other:
            "Quedaron {{count}} líneas sin cobrar.",
          billSummaryTitle_one: "Quedó 1 línea cobrada y sin facturar",
          billSummaryTitle_other:
            "Quedaron {{count}} líneas cobradas y sin facturar",
          billSummaryHelp:
            "El cobro de todas las líneas está firme. Lo que falta son comprobantes por emitir: se pueden reintentar sin volver a cobrar.",
          billSummaryWithFailures_one:
            "Quedó 1 línea sin facturar. El cobro está firme.",
          billSummaryWithFailures_other:
            "Quedaron {{count}} líneas sin facturar. El cobro está firme.",
          confirmProgressCollecting: "Cobrando la línea de {{beneficiary}}...",
          confirmProgressBilling:
            "Facturando a {{beneficiary}}... (la línea ya está cobrada)",
          confirmProgressPaid: "Cobradas: {{count}}",
          confirmProgressBilled: "Facturadas: {{count}}",
          confirmProgressStopped: "Se frenó en la línea de {{beneficiary}}",
          confirmProgressStoppedHelp:
            "Lo ya procesado quedó firme. Al reintentar, el proceso continúa desde esa línea sin repetir ningún pago.",
          confirmProgressNoServer:
            "El servidor no respondió. Puede haberse caído o cortado la conexión.",
          reloadFailed:
            "No se pudieron actualizar los datos: el servidor no respondió. En pantalla quedó la última información leída.",

          withholdingsLinesCollectionLenght: "Retenciones",
          capitalAmount: "Capital",
          interestsAmount: "Intereses",
          arrearsAmount: "Mora",
          arrearsInterestAmount: "Intereses Mora",
          interestsTaxesAmount: "IVA",
          total: "Total",
          generated: "Generado",

          withholdingsLines: {
            installment_Number: "Cuota",
            beneficiary_DocumentNumber: "Documento",
            beneficiary_Name: "Nombre",
            beneficiary_LastName: "Apellido",
            amountGenerated: "Monto",
            excluded: "Excluido",
            totalWithholdingsLines: "Total de retenciones",
            amountSent: "Enviado",
            amountConfirmed: "Confirmado",
            amountConcilied: "Conciliado",
            editAmount: "Editar monto",
            newAmount: "Nuevo monto",
            currentAmount: "Monto actual",
            pendingGrid: "Pendientes de cobrar",
            confirmedGrid: "Cobradas",
            pendingBillingGrid: "Pendientes de facturar",
            billedGrid: "Facturadas",
            noLines: "Sin líneas",
            loadFailed:
              "No se pudieron leer las líneas de la retención: el servidor no respondió. Lo que se ve no refleja el estado real.",
            loadFailedShort: "No se pudieron leer las líneas",
            loadRetry: "Volver a intentar",
            billLine: "Facturar",
            status: {
              header: "Estado",
              notProcessed: "Sin procesar",
              paidNotBilled: "Pago hecho, falta facturar",
              billingFailed: "Falló la facturación",
              toVerify: "Verificar en facturación",
              billed: "Facturada",
              disabled: "Sin facturar (facturación apagada)",
            },
            resolveBilling: {
              action: "Resolver",
              title: "Verificación de facturación",
              explanation:
                "La facturación de {{beneficiary}} se cortó sin respuesta, así que no se sabe si el comprobante se emitió. El pago ya está firme. Verificá en el facturador y elegí qué pasó.",
              reference: "Serie y número del comprobante",
              issued: "Sí se emitió",
              notIssued: "No se emitió",
              issuedHelp:
                "La línea queda facturada y sus pagos marcados, para que no se emita un duplicado.",
              notIssuedHelp:
                "La línea vuelve al reintento normal, que va a emitir el comprobante.",
            },
          },
        },
      },
    },
  },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    lng: "es",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    objectNotation: true,
    resources,
  });

export default i18n;
